import Book from '@/views/book/Book.vue';
import Editor from '@/views/editor/Editor.vue';
import Character from '@/views/manage/character/Character.vue';
import Create from '@/views/manage/create/Create.vue';
import Story from '@/views/manage/story/Story.vue';
import Trash from '@/views/manage/trash/Trash.vue';
import SettingsLayout from '@/views/manage/settings/Settings.vue';
import Profile from '@/views/manage/settings/profile/Profile.vue';
import Account from '@/views/manage/settings/account/Account.vue';
import OrdersLayout from '@/views/manage/orders/Orders.vue';
import Credits from '@/views/manage/orders/credits/Credits.vue';
import RecordLayout from '@/views/manage/orders/record/RecordLayout.vue';
import History from '@/views/manage/orders/history/History.vue';
import Invoice from '@/views/manage/orders/invoice/Invoice.vue';
import TestPreview from '@/views/manage/test-preview/TestPreview.vue';
import TestCharacter from '@/views/manage/test-preview/TestCharacter.vue';
import { createRouter, createWebHistory } from 'vue-router';
import { createRouterGuards } from './guard';

const dashboardPrefix = import.meta.env.VITE_DASHBOARD_PREFIX as string | undefined;

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { name: 'home', path: '/', redirect: '/create' },
    {
      name: 'create',
      path: '/create',
      component: Create,
      meta: { layout: 'workspace', title: '一键创作', requiresAuth: true }
    },
    {
      name: 'character',
      path: '/character',
      component: Character,
      meta: { layout: 'workspace', title: '设计角色', requiresAuth: true }
    },
    {
      name: 'story',
      path: '/story',
      component: Story,
      meta: { layout: 'workspace', title: '我的故事', requiresAuth: true }
    },
    {
      name: 'trash',
      path: '/trash',
      component: Trash,
      meta: { layout: 'workspace', title: '回收站', requiresAuth: true }
    },
    {
      name: 'settings',
      path: '/settings',
      ...(dashboardPrefix ? { alias: `${dashboardPrefix}/settings` } : {}),
      component: SettingsLayout,
      redirect: '/settings/profile',
      meta: { layout: 'workspace', title: '账号设置', requiresAuth: true },
      children: [
        {
          name: 'settings-profile',
          path: 'profile',
          component: Profile,
          meta: { title: '个人信息' }
        },
        {
          name: 'settings-account',
          path: 'account',
          component: Account,
          meta: { title: '账号管理' }
        }
      ]
    },
    {
      name: 'orders',
      path: '/orders',
      ...(dashboardPrefix ? { alias: `${dashboardPrefix}/orders` } : {}),
      component: OrdersLayout,
      redirect: '/orders/records/history',
      meta: { layout: 'workspace', title: '订单和发票', requiresAuth: true },
      children: [
        {
          name: 'orders-credits',
          path: 'credits',
          component: Credits,
          meta: { title: '云币' }
        },
        {
          path: 'history',
          redirect: { name: 'orders-history' }
        },
        {
          path: 'invoice',
          redirect: { name: 'orders-invoice' }
        },
        {
          name: 'orders-records',
          path: 'records',
          component: RecordLayout,
          redirect: { name: 'orders-history' },
          meta: { title: '订单记录' },
          children: [
            {
              name: 'orders-history',
              path: 'history',
              component: History,
              meta: { title: '历史订单' }
            },
            {
              name: 'orders-invoice',
              path: 'invoice',
              component: Invoice,
              meta: { title: '发票申请' }
            }
          ]
        },
        {
          name: 'orders-print',
          path: 'print',
          redirect: { name: 'orders-history' },
          meta: { title: '历史订单' }
        },
        {
          name: 'orders-invite',
          path: 'invite',
          redirect: { name: 'orders-history' },
          meta: { title: '历史订单' }
        }
      ]
    },
    {
      name: 'edit',
      path: '/edit/:id?',
      ...(dashboardPrefix ? { alias: `${dashboardPrefix}/edit/:id?` } : {}),
      component: Editor,
      meta: { layout: 'blank', title: '编辑绘本', requiresAuth: true }
    },
    {
      name: 'book',
      path: '/book/:id?',
      component: Book,
      meta: { layout: 'blank', title: '阅读绘本' }
    },
    {
      name: 'test-preview',
      path: '/test-preview',
      component: TestPreview,
      meta: { layout: 'blank', title: '测试预览' }
    },
    {
      name: 'test-character',
      path: '/test-character',
      component: TestCharacter,
      meta: { layout: 'blank', title: '角色风格化测试' }
    }
  ]
});

createRouterGuards(router);

export default router;
